var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#509fe0",
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,7H9c-1.7,0-3,1.3-3,3v10.7l9.5-5.5c0.3-0.2,0.8-0.2,1.1,0.1l3.5,2.6l5.9-3.6V10C26,8.3,24.7,7,23,7z M12,14 c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S13.1,14,12,14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4,19.8l-3.5-2.6l-9.8,5.7C6.5,24.1,7.7,25,9,25h14c1.7,0,3-1.3,3-3v-5.4l-5.5,3.3C20.2,20.1,19.7,20,19.4,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7,5.7L16,3.4l2.3,2.3C18.5,5.9,18.7,6,19,6s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4l-3-3c-0.4-0.4-1-0.4-1.4,0l-3,3 c-0.4,0.4-0.4,1,0,1.4S13.3,6.1,13.7,5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3,26.3L16,28.6l-2.3-2.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l3,3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l3-3 c0.4-0.4,0.4-1,0-1.4S18.7,25.9,18.3,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7,12.3c-0.4-0.4-1-0.4-1.4,0l-3,3c-0.4,0.4-0.4,1,0,1.4l3,3C3.5,19.9,3.7,20,4,20s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4 L2.4,16l2.3-2.3C5.1,13.3,5.1,12.7,4.7,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7,15.3l-3-3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l2.3,2.3l-2.3,2.3c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3 s0.5-0.1,0.7-0.3l3-3C32.1,16.3,32.1,15.7,31.7,15.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeUpload);
export default __webpack_public_path__ + "static/media/change_upload.db2a5f9ff6749112276f4b82d8fd8fae.svg";
export { ForwardRef as ReactComponent };